
import { supabase } from "@/integrations/supabase/client";

/**
 * Updates the premium status of a user
 * @param userId The ID of the user to update
 * @param isPremium Whether the user should be premium or not
 * @returns Promise resolving to success boolean
 */
export const updateUserPremiumStatus = async (userId: string, isPremium: boolean) => {
  try {
    // For admin users, we can directly update the user_profiles table
    // since the admin RLS policy should allow this operation
    const { data, error } = await supabase
      .from('user_profiles')
      .update({ 
        premium: isPremium,
        updated_at: new Date().toISOString()
      })
      .eq('user_id', userId);
      
    if (error) {
      console.error('Error updating premium status:', error);
      throw error;
    }
    return { success: true, data };
  } catch (error) {
    console.error('Error updating premium status:', error);
    return { success: false, error };
  }
};
